class NavRoutes {
  static PUBLIC = {
    LOGIN: 'login',
    '404': '404',
    PATIENT_LOGIN_ERROR: 'login_error',
    PATIENT_FORMS: {
      DOWNLOAD_FORM: 'download-form'
    }
  };

  static PRIVATE = {
    HOME: 'home',
    USERS: 'users',
    INTERPRETING_PHYSICIANS: 'interpretingPhysicians',
    CASES: 'cases',
    SURGEON_FORMS: 'surgeon-forms',
    PATIENT: {
      DOCUMENTS: "documents",
      UPLOAD_CARDS: 'upload',
      SUCCESS: 'success'
    },
    CONFIGURATIONS: 'configurations',
    PATIENTPORTAL: 'patient',
    SURGEONS: 'surgeons'
  };
}

export default NavRoutes;